import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from "@react-navigation/native";
import * as React from "react";
import { StatusBar, StyleSheet } from "react-native";
export default function ModalStatusBarManager(param) {
    var dark = param.dark, layout = param.layout, insets = param.insets, style = param.style;
    var _flattenedStyle_transform_find, _flattenedStyle_transform;
    var _useTheme = useTheme(), darkTheme = _useTheme.dark;
    var _React_useState = _sliced_to_array(React.useState(true), 2), overlapping = _React_useState[0], setOverlapping = _React_useState[1];
    var scale = 1 - 20 / layout.width;
    var offset = (insets.top - 34) * scale;
    var flattenedStyle = StyleSheet.flatten(style);
    var translateY = flattenedStyle === null || flattenedStyle === void 0 ? void 0 : (_flattenedStyle_transform = flattenedStyle.transform) === null || _flattenedStyle_transform === void 0 ? void 0 : (_flattenedStyle_transform_find = _flattenedStyle_transform.find(function(s) {
        return s.translateY !== undefined;
    })) === null || _flattenedStyle_transform_find === void 0 ? void 0 : _flattenedStyle_transform_find.translateY;
    React.useEffect(function() {
        var listener = function(param) {
            var value = param.value;
            setOverlapping(value < offset);
        };
        var sub = translateY === null || translateY === void 0 ? void 0 : translateY.addListener(listener);
        return function() {
            return translateY === null || translateY === void 0 ? void 0 : translateY.removeListener(sub);
        };
    }, [
        offset,
        translateY
    ]);
    var darkContent = dark !== null && dark !== void 0 ? dark : !darkTheme;
    return /*#__PURE__*/ _jsx(StatusBar, {
        animated: true,
        barStyle: overlapping && darkContent ? "dark-content" : "light-content"
    });
}
